import { useState } from "react";
import { cn } from "../../lib/utils";

export default function TagsInput({
  value = [],
  onChange,
  placeholder,
  disabled,
}) {
  const [input, setInput] = useState("");

  const addTag = (val) => {
    const newTags = val
      .split(",")
      .map((t) => t.trim())
      .filter((t) => t !== "" && !value.includes(t));

    if (newTags.length > 0) {
      onChange([...value, ...newTags]);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      if (input.trim() !== "") {
        addTag(input);
        setInput("");
      }
    }
  };

  const removeTag = (i) => {
    onChange(value.filter((_, idx) => idx !== i));
  };

  // console.log(value)
  return (
    <div className="flex flex-col gap-2">
      {!disabled && (
        <p className="text-sm text-neutral700 font-medium">
          Type and press enter to add a domain or IP address
        </p>
      )}
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className={cn(
          disabled && "cursor-not-allowed opacity-50",
          "flex-1 min-w-[150px] border border-gray-300 rounded-lg p-2 text-sm"
        )}
      />

      <div className="flex flex-wrap gap-2">
        {value.map((tag, i) => (
          <div
            key={i}
            className="flex items-center gap-2 bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-sm"
          >
            <span>{tag}</span>
            {!disabled && (
              <button
                type="button"
                onClick={() => removeTag(i)}
                className="text-blue-500 hover:text-blue-700 focus:outline-none"
              >
                ×
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
